import { useCurrentRoute } from '@/libs/hooks';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useIntl, useModel } from '@umijs/max';
import { Space } from 'antd';
import classNames from 'classnames';
import React from 'react';
import HeaderSearch from '../HeaderSearch';
import HeaderSelectLang from '../HeaderSelectLang';
import { introductionsTarget } from '../Introduction';
import NoticeIconView from '../NoticeIcon';
import NoticeTransitIcon from '../NoticeTransitIcon';
import AvatarDropdown from './AvatarDropdown';
import styles from './index.less';

export type SiderTheme = 'light' | 'dark';

const GlobalHeaderRight: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const int = useIntl();
  const currentRoute = useCurrentRoute();

  if (!initialState || !initialState.settings) {
    return null;
  }

  const { navTheme, layout } = initialState.settings;
  let className = styles.right;

  if ((navTheme === 'realDark' && layout === 'top') || layout === 'mix') {
    className = `${styles.right}  ${styles.dark}`;
  }

  const getNoticeView = () => {
    switch (currentRoute?.customRightContent?.notification) {
      case 'transit-notification':
        return <NoticeTransitIcon />;
      default:
        return <NoticeIconView />;
    }
  };

  return (
    <Space className={className}>
      <HeaderSearch
        className={`${styles.action} ${styles.search}`}
        placeholder={int.formatMessage({
          id: 'common.text.search',
          defaultMessage: 'Tìm kiếm',
        })}
        options={[]}
        // onSearch={value => {
        //   console.log('input', value);
        // }}
      />
      <span
        className={styles.action}
        onClick={() => {
          window.open('https://pro.ant.design/docs/getting-started');
        }}
      >
        <QuestionCircleOutlined />
      </span>
      {getNoticeView()}
      <HeaderSelectLang
        className={classNames(
          introductionsTarget.dashboard.languageButton.substr(1),
          styles.action,
        )}
        trigger={['click']}
      />
      <AvatarDropdown />
    </Space>
  );
};

export default GlobalHeaderRight;
